export const apis = {
  user: {
    Profile: '/api/customer/getcustomerprofile',
    EncryptedProfile: '/api/customer/getcustomerprofilebyencrypteddata',
    UpdateProfile: '/api/customer/updatecustomerprofile',
    Login: '/api/customer/web/login',
    Logout: '/api/customer/logout',
    Register: '/api/customer/registercustomer',
    UpdateNotifyToken: '/api/customer/updatenotifytoken',
    UpdatePassword: '/api/customer/updatepassword',
    UpdateMobileStatus: '/api/customer/updatemobilenostatus',
    SendOTP: '/api/customer/sendotp',
    VerifyOTP: '/api/customer/verifyotp',
    ConfirmEmailStatus: '/api/customer/confirmemailstatus',
    RefreshToken: '/api/customer/web/refreshtoken',
    VerifyUpdateMobileNo: '/api/customer/verifyupdatemobileno',
    SendEmailVerification: '/api/customer/sendemailverification',
    ForgotPassword: '/api/customer/resetpassword',
    RegisterCustomerAddress: '/api/customer/registercustomeraddress',
    UpdateCustomerAddress: '/api/customer/updatecustomeraddress',
    DeleteCustomerAddress: '/api/customer/deletecustomeraddress',
    GetCustomerAddress: '/api/customer/getcustomeraddress',
    GetCustomerSavedCard: '/api/customer/getcustomersavedcard',
    DeleteCustomerSavedCard: '/api/customer/removecustomersavedcard',
    GetFavouriteStore: '/api/customer/getfavouritestore',
    DeleteFavouriteStore: '/api/customer/removefavouritestore',
    AddFavouriteStore: '/api/customer/addfavouritestore',
    UpdateChatId: '/api/customer/updatechatid',
    DeleteCustomer: '/api/customer/deletecustomer',
    GetCustomerProfileStatus: '/api/customer/getcustomerprofilestatus'
  },
  channel: {
    GetChannelData: '/api/channel/getchanneldata',
    GetChannelHomeSection: '/api/channel/getchannelhomesection',
    SwitchChannel: '/api/channel/switchchannel',
    PlaceAutoComplete: '/api/channel/placeautocomplete',
    GetPlaceDetails: '/api/channel/getplacedetails',
    GetlocationAddress: '/api/channel/getlocationaddress'
  },
  merchant: {
    GetOrderMenu: '/api/external/general/getordermenu'
  },
  order: {
    GetActivitySummary: '/api/order/getactivitysummary',
    GetActivityDetail: '/api/order/getactivitydetail',
    GetOrderSummary: '/api/order/getordersummary',
    GetOrderDataHistory: '/api/order/getorderdatahistory',
    CheckoutOrder: '/api/order/checkoutorder',
    AcceptOrder: '/api/order/acceptOrder',
    ReceiptRequest: '/api/order/receiptrequest',
    SubmitOrder: '/api/order/submitorder',
    GetActivityByLinkId: '/api/order/getactivitybylinkid',
    ConfirmPickupOrder: '/api/order/confirmpickuporder',
    UpdateCustomer: '/api/order/updatecustomer',
    GetActivityByOrders: '/api/order/getactivitybyorders',
    RevertCutOffOrder: '/api/order/revertcutofforder',
    GetActivityByRsvTokenId: '/api/order/getactivitybyrsvtokenid',
    GetActivityByActivityGuid: '/api/order/getactivitybyactivityguid',
    OrderPaymentSafetyCheck: '/api/order/orderpaymentsafetycheck'
  },
  store: {
    GetOrderMenu: '/api/external/general/getordermenu',
    GetOutlets: '/api/store/getoutlets',
    GetStoreMenuData: '/api/store/getstoremenudata',
    GetStore: '/api/store/getstore',
    GetStores: '/api/store/getstores',
    GetStoreForQueue: '/api/store/getstoreforqueue'
  },
  cart: {
    RecalculateCart: '/api/cart/recalculatecart',
    GetCustomerCart: '/api/cart/getcustomercart',
  },
  review: {
    UpdateStoreReview: '/api/review/updatestorereview',
    GetChannelReviewText: '/api/review/getchannelreviewtext',
    GetStoreReviewData: '/api/review/getstorereviewdata',
  },
  webLink: {
    validateweblinktoken: '/api/weblink/validateweblinktoken',
  },
  voucher: {
    GetVoucherTypeByVchTypCode: '/api/voucher/getvouchertypebyvchtypcode',
    GetVoucherTypeByVchTypId: '/api/voucher/getvouchertypebyvchtypid',
    GetStoreVoucherType: '/api/voucher/getstorevouchertype',
    GetNearbyVoucherType: '/api/voucher/getnearbyvouchertype',
    GetVoucherTypeCategories: '/api/voucher/getvouchertypecategories',
    ClaimVoucher: '/api/voucher/claimvoucher',
    GetCustomerClaimedVoucher: '/api/voucher/getcustomerclaimedvoucher',
    GetApplicableVoucher: '/api/voucher/getapplicablevoucher',
    GetCustomerVoucherHistory: '/api/voucher/getcustomervoucherhistory',
    Redeemmembershipvoucher: '/api/voucher/redeemmembershipvoucher',
    Getmemberclaimedvoucher: '/api/voucher/getmemberclaimedvoucher',
  },
  queue: {
    GetOrJoinQueue: '/api/queue/getorjoinqueue',
    GetQueueByToken: '/api/queue/getqueuebytoken',
    UpdateQueueInfo: '/api/queue/updatequeueinfo',
    CancelQueue: '/api/queue/cancelqueue',
    AcknowledgeQueue: '/api/queue/acknowledgequeue'
  },
  infoPanel: {
    GetInfoPanelData: '/api/infopanel/getinfopaneldata'
  },
  membership: {
    GetMembershipTermsData: '/api/membership/getmembershiptermsdata',
    JoinMembership: '/api/membership/joinmembership',
    QuitMembership: '/api/membership/quitmembership',
    GetMembershipDetails: '/api/membership/getmembershipdetails',
    GetCustomerMemberships: '/api/membership/getcustomermemberships',
    GetMembershipRewardHistory: '/api/membership/getmembershiprewardhistory',
    Getmembershipbylogin: '/api/membership/getmembershipbylogin',
    ValidateExternalLoginCallback: '/api/membership/validateexternallogincallback',
    ExternalLoginURL: '/api/membership/externalloginurl',
    UpdateMemberInfo: '/api/membership/updatememberinfo',
    GetMemberships: '/api/membership/getmemberships'
  },
  appLink: {
    GetAppLinkToken: '/api/applink/getapplinktoken'
  },
  messenger: {
    GenerateMessageLink: '/api/messenger/generatemessengerlink',
    GetMessageStatus: '/api/messenger/getmessagestatus',
  }
};